import React from 'react';
import CheckCircleGreenIcon from '@/shared/icons/CheckCircleGreenIcon';

/** Strip leading numbers/units (e.g. "20 AI agents" → "ai agents") for fuzzy matching */
const stripNumericPrefix = (s) => s.replace(/^[\d,.\s]+[A-Z]*\s*/i, '').toLowerCase();

const labelsMatch = (a, b) => {
  if (a.toLowerCase() === b.toLowerCase()) return true;
  return stripNumericPrefix(a) === stripNumericPrefix(b);
};

const FeaturesList = ({ features, maxFeatures, highlightFeature }) => {
  let orderedFeatures = maxFeatures ? features.slice(0, maxFeatures) : [...features];

  if (highlightFeature) {
    const idx = orderedFeatures.findIndex((f) => labelsMatch(f, highlightFeature));
    if (idx > 0) {
      const [item] = orderedFeatures.splice(idx, 1);
      orderedFeatures.unshift(item);
    } else if (idx === -1) {
      const fullIdx = features.findIndex((f) => labelsMatch(f, highlightFeature));
      if (fullIdx !== -1) {
        orderedFeatures = [
          features[fullIdx],
          ...orderedFeatures.slice(0, (maxFeatures || features.length) - 1),
        ];
      }
    }
  }

  return (
    <div className="flex flex-col items-start w-full gap-v3-xs">
      {orderedFeatures.map((featureLabel) => {
        const isHighlighted =
          highlightFeature && labelsMatch(featureLabel, highlightFeature);
        return (
          <div key={featureLabel} className="flex items-center gap-v3-xs">
            <CheckCircleGreenIcon
              className={`flex-shrink-0 ${isHighlighted ? 'text-v3-purple-dark' : 'text-emerald-500'}`}
            />
            <span
              className={`font-inter-variable text-[13px] font-medium leading-4 ${
                isHighlighted ? 'text-v3-purple-dark' : 'text-v3-black-max'
              }`}
            >
              {featureLabel}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default FeaturesList;
